import React from 'react';
import Box from '@material-ui/core/Box';

import { NavigationLink } from './NavigationLink';

export const DefaultNavigation: React.FC = ({ ...other }) => (
  <Box {...other}>
    <NavigationLink to="/">Home</NavigationLink>
    <NavigationLink to="/azienda">Azienda</NavigationLink>
    <NavigationLink to="/negozio">Negozio</NavigationLink>
    <NavigationLink to="/ordina">Ordina online</NavigationLink>
    <NavigationLink to="/contatti">Contatti</NavigationLink>
  </Box>
);
